import { renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6a8c12e8")

_pushScopeId("data-v-6a8c12e8")
const _hoisted_1 = {
  key: 0,
  class: "plane-background"
}
const _hoisted_2 = { class: "plane-content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ["plane flex flex--v flex--valign-c flex--halign-c", { 'plane--darker': _ctx.darker, 'plane--rounded': _ctx.rounded, 'plane--rounded-bottom': _ctx.roundedBottom, 'plane--primary': _ctx.primary, 'plane--secondary': _ctx.secondary }],
    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
  }, [
    (!!_ctx.$slots.background)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "background", {}, undefined, true)
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ], 2))
})